import { render } from "./SquarePixel.vue?vue&type=template&id=5ce13084&scoped=true"
import script from "./SquarePixel.vue?vue&type=script&lang=js"
export * from "./SquarePixel.vue?vue&type=script&lang=js"

import "./SquarePixel.vue?vue&type=style&index=0&id=5ce13084&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce13084"]])

export default __exports__